// 戦闘に持ち出す道具（2種類）。出撃画面の欄と、選ぶ札（下から出る）
import { ITEM_IDS, ITEM_SLOTS, ITEM_UNLOCK, BATTLE_CONFIG, battleItemsOf, ownsItem, type CharId, type ItemId } from '@hyakki/core';
import { api } from '../api';
import { battleItemArt } from '../assets';
import { act, state } from '../state';
import { esc } from './dom';
import { icon } from './icons';
import { openModal, toast } from './overlay';
import { errorText } from './status';

const info = (id: ItemId) => BATTLE_CONFIG.items[id];

/** 道具を選ぶ札：持っている道具から2つまで（万屋で解放）。決定でサーバーへ */
export function openItemsSheet(onDone?: () => void, charId?: CharId) {
  const p = state.profile;
  if (!p) return;
  let pick = battleItemsOf(p, charId).slice();
  const lv = p.level;
  const html = () =>
    `<div class="it-list">${ITEM_IDS.map((id) => {
      const d = info(id);
      const locked = !ownsItem(p, id);
      const on = pick.includes(id);
      return `<button class="it-row ${on ? 'on' : ''}" data-item="${id}" ${locked ? 'disabled' : ''} aria-pressed="${on}">
        <span class="it-ic big it-art ${locked ? 'locked' : ''}" style="${battleItemArt(id)}"></span><span class="grow"><b>${esc(d.name)}</b><small>${locked ? (lv < ITEM_UNLOCK[id] ? `主Lv${ITEM_UNLOCK[id]}で里の万屋に並ぶ` : '里の万屋で解放') : esc(d.desc)}</small></span>
        <span class="it-check">${on ? icon('check') : ''}</span></button>`;
    }).join('')}</div>
    <button class="btn primary big it-ok" data-items-ok ${pick.length ? '' : 'disabled'}>決定</button>`;
  const m = openModal(`<div class="it-sheet">${html()}</div>`, { title: `道具（${ITEM_SLOTS}つまで）`, className: 'sheet-wrap navy-sheet it-sheet-wrap' });
  const body = m.body.querySelector<HTMLElement>('.it-sheet')!;
  m.body.addEventListener('click', async (e) => {
    const t = e.target as HTMLElement;
    const row = t.closest<HTMLButtonElement>('[data-item]');
    if (row && !row.disabled) {
      const id = row.dataset.item as ItemId;
      if (pick.includes(id)) pick = pick.filter((x) => x !== id);
      else pick = [...pick, id].slice(-ITEM_SLOTS); // 3つ目を選んだら古い方を外す
      body.innerHTML = html();
      return;
    }
    const ok = t.closest<HTMLButtonElement>('[data-items-ok]');
    if (ok && !ok.disabled) {
      ok.disabled = true;
      try {
        await act(api.setItems(pick, charId));
        toast(`道具：${pick.map((id) => info(id).name).join('・')}`, 'good');
        m.close();
        onDone?.();
      } catch (err) {
        toast(errorText(err), 'error');
        ok.disabled = false;
      }
    }
  });
}

/** root の中の [data-items-open] を扱う。戻り値で外す */
export function bindItemsActions(root: HTMLElement, onDone?: () => void): () => void {
  const h = (e: Event) => {
    const open = (e.target as HTMLElement).closest<HTMLButtonElement>('[data-items-open]');
    if (open && !open.disabled) {
      e.stopPropagation();
      openItemsSheet(onDone, (open.dataset.itemsChar as CharId | undefined) || undefined);
    }
  };
  root.addEventListener('click', h);
  return () => root.removeEventListener('click', h);
}
